export const removeAllSlashes = (a: string) => a.replace(/\//g, '');
